module.exports = __webpack_public_path__ + "img/close.5ea9d55f.svg";